import { ParsedUrlQuery } from 'querystring';
import { QUERY } from '@/constants/common';

export function shouldSkipSearchCategoryQuery(query: ParsedUrlQuery) {
  const { slug } = query;

  if (!slug || slug === 'vip') {
    return true;
  }

  if (Array.isArray(slug) && slug[0] === 'vip') {
    return true;
  }

  return Boolean(query[QUERY.userId]);
}
